export default {
  main: {
    menu: {
      admin: 'Administration',
      admin_users: 'Administrateurs',
      users: 'Utilisateurs',

      formaat: 'Formaât',
      clients: 'Clients',
    },
    tabsbar: {
      options: 'Options',
      close_all: 'Tout fermer',
      close_other: 'Femer autre',
    },
  },
};
